export const tableScrollbarStyles = (theme) => ({
  overflow: "auto",

  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },

  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 10,
  },

  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },

  scrollbarWidth: "thin",
  scrollbarColor: `${theme.palette.primary.main} transparent`,
});
